import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SettingsApi } from 'src/app/hickory-api';
import { AuthService } from '../../authentication/auth.service';
import { MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { SelectionModel } from '@angular/cdk/collections';
import { AuthorizationViewModel, AuthZDialogData } from '../shared/shared-authz-models';

@Component({
  selector: 'app-add-role-authorization',
  templateUrl: './add-role-authorization.component.html',
  styleUrl: './add-role-authorization.component.scss',
  standalone: false
})
export class AddRoleAuthorizationComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<AddRoleAuthorizationComponent>);
  readonly data = inject<AuthZDialogData>(MAT_DIALOG_DATA);

  availableRoles: AuthorizationViewModel[] = [];
  selectedRoles: AuthorizationViewModel[] = [];
  @ViewChild(MatSelectionList) selectionList: MatSelectionList;
  selection: SelectionModel<AuthorizationViewModel>;

  private tenantId: number;

  constructor(
    private settingsApi: SettingsApi,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.selectedRoles = this.getInitialValues();
    this.selection = new SelectionModel<AuthorizationViewModel>(true);
    this.tenantId = this.data?.tenantId || this.authService.user.snapshot?.tenantId;
    this.loadRoles();
  }

  getInitialValues() {
    return this.data.currentSelection.map(r => {
      const role = new AuthorizationViewModel();
      role.id = r.id;
      role.name = r.name;
      return role;
    })
  }

  loadRoles(): void {
    this.settingsApi.getRolesV4(this.tenantId, 1, 100, null, true)
      .subscribe(r => {
        this.availableRoles = r.items?.map(role => {
          const authz = new AuthorizationViewModel();
          authz.id = role.id;
          authz.name = role.name;
          authz.selected = this.selectedRoles.findIndex(sr => sr.id == role.id) !== -1;
          if (authz.selected) { this.selection.select(authz); }
          return authz;
        });
      });
  }

  change(event: MatSelectionListChange) {
    const selectedItem = event.options[0].value;
    this.selection.toggle(selectedItem);
  }

  onCancel() {
    this.dialogRef.close();
  }

  onGrantAccess() {
    console.log({ selected: this.selection.selected });
    this.dialogRef.close({ selected: this.selection.selected });
  }

  roleSelected(role: AuthorizationViewModel) {
    return this.selection.isSelected(role);
  }
}